import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';
import { DelaStarIcon } from '~/modules/common/components';
import { useBulkMarkResourceRequestsAsSubmitted } from '../hooks';

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(1, 2, 1, 1.5),
    borderRadius: theme.spacing(2.5),
    color: theme.palette.common.white,
    backgroundImage: `linear-gradient(119deg, ${theme.palette.Dela.button.gradient.purple} 17.59%, ${theme.palette.Dela.button.gradient.blue} 77.78%)`,
    boxShadow: 'none',
    zIndex: 100
  },
  root2: {
    padding: theme.spacing(0.5, 2),
    borderRadius: theme.spacing(2.5),
    color: theme.palette.common.white,
    backgroundImage: `linear-gradient(119deg, ${theme.palette.Dela.button.gradient.purple} 17.59%, ${theme.palette.Dela.button.gradient.blue} 77.78%)`,
    boxShadow: 'none'
  },
  text: {
    textTransform: 'uppercase'
  },
  delaStarIcon: {
    color: theme.palette.common.white,
    fontSize: theme.spacing(1.75),
    marginRight: theme.spacing(0.5)
  }
}));

export const ResourceRequestSubmitAllButton = ({ resourceRequestIds }) => {
  const classes = useStyles();
  const {
    bulkMarkResourceRequestsAsSubmitted
  } = useBulkMarkResourceRequestsAsSubmitted();

  const handleSubmitAll = useCallback(() => {
    bulkMarkResourceRequestsAsSubmitted(resourceRequestIds);
  }, [bulkMarkResourceRequestsAsSubmitted, resourceRequestIds]);

  return (
    <Button
      className={classes.root2}
      onClick={handleSubmitAll}
      variant="contained"
    >
      <DelaStarIcon className={classes.delaStarIcon} />
      <FormattedMessage
        className={classes.text}
        id="resourceRequestChartBanner.submitAll"
      />
    </Button>
  );
};

ResourceRequestSubmitAllButton.propTypes = {
  resourceRequestIds: PropTypes.array.isRequired
};

export default ResourceRequestSubmitAllButton;
